import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Control Panel", -1)
const _hoisted_2 = { style: {"height":"100%","display":"flex","align-items":"center"} }
const _hoisted_3 = { style: {"margin-left":"10px","font-weight":"bold"} }
const _hoisted_4 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 실행 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_slider = _resolveComponent("a-slider")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { style: {"height":"100%"} }, {
    title: _withCtx(() => [
      _createVNode(_component_a_row, { type: "flex" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { flex: "1 1 120px" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.makeupParamOptions, ({ label, min, max }, index) => {
        return (_openBlock(), _createBlock(_component_a_row, {
          key: 'makeup-' + index,
          style: {"display":"flex"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 10 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", null, _toDisplayString(label), 1),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.makeupParamOptions[index].value) + " " + _toDisplayString(_ctx.makeupParamOptions[index].unit), 1)
                ])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_col, { span: 14 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_slider, {
                  value: _ctx.makeupParamOptions[index].value,
                  "onUpdate:value": ($event: any) => ((_ctx.makeupParamOptions[index].value) = $event),
                  style: {"width":"100%"},
                  "tip-formatter": _ctx.formatter,
                  min: min,
                  max: max
                }, null, 8, ["value", "onUpdate:value", "tip-formatter", "min", "max"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createVNode(_component_a_divider),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_button, {
          type: "primary",
          disabled: _ctx.disabled,
          onClick: _ctx.onClick
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _: 1
  }))
}